import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fas fa-check text-green-500"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_cheap = _resolveComponent("cheap")!

  return (_ctx.column.key === 'index')
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createTextVNode(_toDisplayString(_ctx.index), 1)
      ], 64))
    : (_ctx.column.key === 'hasAdditionalService')
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.row.hasAdditionalService)
            ? (_openBlock(), _createElementBlock("i", _hoisted_1))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
        ], 64))
      : (_ctx.column.key === 'status')
        ? (_openBlock(), _createBlock(_component_cheap, {
            key: 2,
            class: _normalizeClass(`w-max small ${_ctx.NewDispatcherStatusesEnum[_ctx.row.status]}`)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.row.status || '-'), 1)
            ]),
            _: 1
          }, 8, ["class"]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createTextVNode(_toDisplayString(_ctx.row[_ctx.column.key]), 1)
          ], 64))
}